import React from 'react';
import Card from 'react-bootstrap/Card';
import { Divider } from '@mui/material';

const CardProducto = ({producto}) => {

  return (
    <>
    <Card className="card-product" style={{ width: '19.6rem' }}>
      <a href={`/producto/subProducto/${producto?.title}`}>
        <Card.Title className='title-producto'>{producto?.subCategory}</Card.Title>
            <div className="image-card">
              <Card.Img variant="top" src={producto?.imageProduct?.[0]?.url} />
            </div>
            <Card.Body>
                <Card.Title className='nombre-producto'>{producto?.title}</Card.Title>
                <Divider className='divider' />
                <Card.Text className='info-producto'>
                    Dimensiones: {producto?.dimension} <br />
                    Cantidad/m2: {producto?.quantity}<br />
                    Peso: {producto?.weight} kg
                </Card.Text>
            </Card.Body>
      </a>
    </Card>
    </>
  )
}

export default CardProducto